import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "./index";
import User, * as UserModel from "@/models/user";
import moment from "moment";

export interface ReportState {
  user: UserModel.default[];
  start?: string;
  end?: string;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "report",
})
class Report extends VuexModule implements ReportState {
  user: UserModel.default[] = [];
  start = moment().subtract(12, "months").format();
  end = moment().format();

  get startFilter() {
    return this.start;
  }

  get endFilter() {
    return this.end;
  }

  get userFilter() {
    return this.user;
  }

  @Mutation
  setUserFilter(user: UserModel.default[]) {
    this.user = user;
  }

  @Mutation
  setStartFilter(value: string) {
    this.start = value;
  }

  @Mutation
  setEndFilter(value: string) {
    this.end = value;
  }
}

export const ReportModule = getModule(Report);
